import React from 'react';
import { Stack, Tooltip } from 'omaha-design-system';

interface BattingOrderBadgeProps {
  battingOrder: number;
  confirmedLineup?: boolean | null;
  /** Badge size — defaults to 18px */
  size?: number;
}

const BattingOrderBadge: React.FC<BattingOrderBadgeProps> = ({
  battingOrder,
  confirmedLineup,
  size = 18,
}) => {
  const tooltip = confirmedLineup === null
    ? 'Not playing'
    : confirmedLineup
    ? 'Confirmed lineup'
    : 'Probable lineup';

  const bgColor = confirmedLineup === null
    ? '#640600'
    : confirmedLineup
    ? 'rgba(0, 181, 83, 0.6)'
    : '#AA9900';

  const textColor = confirmedLineup === null ? '#FFBDC5' : '#fff';

  return (
    <Tooltip title={tooltip} arrow>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{
          bgcolor: bgColor,
          borderRadius: '2px',
          height: size,
          width: size,
          fontFamily: '"Instrument Sans", sans-serif',
          fontSize: size <= 18 ? '10px' : '11px',
          fontWeight: 700,
          color: textColor,
          flexShrink: 0,
        }}
      >
        {battingOrder === 0 ? 'P' : battingOrder}
      </Stack>
    </Tooltip>
  );
};

export default BattingOrderBadge;
